import { combineReducers } from "redux";

// Reducers
import reducer from "./reducer";

export default combineReducers({
  files: reducer,
});
